import { memo, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getTax } from '../../selectors/cart'
import { ReactComponent as CloseIcon } from '../../assets/icons/Close-Icon.svg'
import cn from 'classnames'
import styles from './VNCartTaxButton.module.scss'
import { setTaxDisplayDialog } from '../../VNDialogs/ActionCreators'
import { centsToDollars } from '../../utils/formatters'
import { getTabsModeEnabled } from '../../selectors/menus'
import { setManagerApprovalPrompt } from '../../VNManagerApproval/ActionCreators'
import useTaxes from '../hooks/useTaxes'
import { getIsOrderTaxExempt } from '../Selectors'

const VNCartTaxButton = ({ className }) => {
  const classNames = cn(styles.VNCartTaxButton, className)
  const tax = useSelector((state) => getTax(state, true)) //skip tax exemptions
  const taxExempt = useSelector(getIsOrderTaxExempt)

  const dispatch = useDispatch()
  const tabsModeEnabled = useSelector(getTabsModeEnabled)
  const { exemptTax } = useTaxes()

  const label = useMemo(() => {
    if (taxExempt) return 'Tax Exempted'

    return 'Tax'
  }, [taxExempt])

  const handleButtonClick = () => {
    dispatch(setTaxDisplayDialog({ open: true }))
  }

  const handleCloseIconClick = (event) => {
    dispatch(setManagerApprovalPrompt({ onSuccess: exemptTax, buttonText: 'Exempt Tax' }))
    event.stopPropagation()
  }

  if (tax <= 0 || tabsModeEnabled) {
    return null
  }

  return (
    <div className={classNames}>
      <div className={cn([styles.taxContainer, taxExempt && styles.taxExempt])} onClick={handleButtonClick}>
        <div className={cn([styles.label])}>{label}</div>
        <div className={cn([styles.price])}>{centsToDollars(tax)}</div>
      </div>
      {!taxExempt && <CloseIcon className={styles.closeIcon} onClick={handleCloseIconClick} />}
    </div>
  )
}

export default memo(VNCartTaxButton)
